import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { api } from '../consts/url';
import { OrganizationModels } from '@share-models';

@Injectable({ providedIn: 'root' })
export class OrganizationService {
  constructor(private readonly http: HttpClient) {}

  public getActiveOrganization(): Observable<OrganizationModels.OrganizationDocument> {
    return this.http.get<OrganizationModels.OrganizationDocument>(api.organization.crud);
  }

  public getMyOrganizations(): Observable<OrganizationModels.UserOrganizationDropDown[]> {
    return this.http.get<OrganizationModels.UserOrganizationDropDown[]>(api.organization.myOrganizations);
  }
}
